import { selectDeliveryContact } from '@repo/api-adapters/selectors/customer.selectors';

import { QueryError } from '@/components/query-error';
import { ShareModal } from '@/components/share';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';

interface Props {
    visible: boolean;
    onClose: () => void;
}

export const AssetShareModal = ({ visible, onClose }: Props) => {
    const { assetId, assetType } = useAssetParams();
    const { data, isError, error } = useAsset(assetType, assetId);

    if (isError && !data) {
        return <QueryError error={error} />;
    }
    if (!data) {
        return null;
    }

    const deliveryContact = selectDeliveryContact(data);

    return (
        <ShareModal
            visible={visible}
            onClose={onClose}
            data={data}
            initialEmail={deliveryContact?.email}
            initialSms={deliveryContact?.mobilePhone}
        />
    );
};
